<template>
  <div>
    <div class="centered-header">
      <h1 class="ui header" style="color: #092442;">
        <i class="flag outline icon"></i>
        <div class="content">
          Finalize Visit
        </div>
      </h1>
    </div>

    <div class="ui divider"></div>
    <div class="ui raised segment packageSegment" v-if="isAdmin()">
      <div class="ui toggle checkbox">
        <input type="checkbox" v-model="doctorProfitFlag" />
        <label>Discard Doctor Percentage</label>
      </div>
    </div>

    <div v-if="Array.isArray(visitDetails) && visitDetails.length > 0">
      <form @submit="submitForm" novalidate="true">
        <div
          v-for="(visitDetail, visitDetailIndex) in visitDetails"
          :key="visitDetailIndex"
        >
          <div class="ui vertical raised segment packageSegment">
            <div class="ui stackable center aligned grid">
              <div class="six wide column">
                <h2>Enter Discount For This Package</h2>
                <div>
                  <h3>{{ visitDetail.package.name }}</h3>
                  <div class="ui input right labeled" style="width: 80%">
                    <label class="ui red label">
                      Discount
                    </label>
                    <input
                      type="number"
                      min="0"
                      step="0.25"
                      max="100"
                      v-model="
                        visitDetailsForm[visitDetailIndex].discountAmount
                      "
                    />
                    <div class="ui basic label">
                      E£
                    </div>
                  </div>
                </div>

                <final-prices
                  v-if="isAdmin()"
                  v-on:onCostFormUpdate="onCostFormUpdate"
                  :visitDetailIndex="visitDetailIndex"
                />
              </div>
              <div class="one wide column">
                <div class="ui vertical divider"></div>
              </div>

              <div class="nine wide column">
                <div
                  v-if="visitDetail.items.length === 0"
                  class="centered-text"
                >
                  <h2>No more data required for this package.</h2>
                </div>
                <div
                  v-else
                  v-for="(visitDetailItem, itemIndex) in visitDetail.items"
                  :key="visitDetailItem.item.id"
                >
                  <visit-detail-item
                    :entityType="visitDetail.entity_type"
                    :maxSum="
                      visitDetail.visit_detail.quantity
                    "
                    :visitDetailItem="visitDetailItem"
                    :visitDetailIndex="visitDetailIndex"
                    :itemIndex="itemIndex"
                    v-on:onItemUpdate="onItemUpdate"
                    :showErrors="showErrors"
                  ></visit-detail-item>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="submitButton">
          <button type="submit" class="ui primary button" :disabled="!isValid || isPressed">
            Submit
          </button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import FinalPrices from './finalize-visits-components/FinalPrices.vue';
import VisitDetailItem from './finalize-visits-components/VisitDetailItem.vue';

export default {
  components: { VisitDetailItem, FinalPrices },
  data() {
    return {
      reservationVisitId: this.$route.params.reservationVisitId,
      doctorProfitFlag: false,
      visitDetails: undefined,
      visitDetailsForm: [],
      showErrors: false,
      isValid: false,
      isPressed: false
    };
  },
  async mounted() {
    if (this.reservationVisitId) {
      this.visitDetails = await this.getVisitDetails();
      this.mapToForm();
    }
  },
  methods: {
    onItemUpdate(event) {
      if (!event.isValid) this.isValid = false;
      // for the visit detail index and item index in it add the invoice entries
      this.visitDetailsForm[event.visitDetailIndex]['items'][
        event.itemIndex
      ] = {
        itemId: this.visitDetailsForm[event.visitDetailIndex]['items'][
          event.itemIndex
        ].itemId,
        invoicesForm: event.invoicesForm,
        isValid: event.isValid
      };
      this.validateForm();
    },
    onCostFormUpdate(event) {
      this.visitDetailsForm[event.visitDetailIndex].finalCostPrice =
        event.finalCostPrice;
      this.visitDetailsForm[event.visitDetailIndex].finalSellingPrice =
        event.finalSellingPrice;
      this.visitDetailsForm[
        event.visitDetailIndex
      ].finalDoctorPercentage = event.finalDoctorPercentage;
    },
    async getVisitDetails() {
      return this.$http
        .get(`reservation_visits/${this.reservationVisitId}/visit/packages/data`, {
          params: {
            clinic_id: this.clinicId
          }
        })
        .then(res => res.data);
    },
    mapToForm() {
      if (Array.isArray(this.visitDetails) && this.visitDetails.length > 0) {
        this.visitDetailsForm = this.visitDetails.map(visitDetail => {
          let items = [];
          if (
            Array.isArray(visitDetail.items) &&
            visitDetail.items.length > 0
          ) {
            items = visitDetail.items.map(visitDetailItem => {
              return {
                itemId: visitDetailItem.item.id,
                isValid: false
              };
            });
          }
          return {
            visitDetailId: visitDetail.visit_detail.id,
            packageId: visitDetail.visit_detail.package_id,
            finalCostPrice: null,
            finalSellingPrice: null,
            finalDoctorPercentage: null,
            discountAmount: visitDetail.visit_detail.discount_amount,
            items
          };
        });
      } else {
        this.visitDetailsForm = [];
      }
      this.validateForm();
    },
    addInvoiceEntry(visitDetailIndex, itemIndex) {
      this.visitDetailsForm[visitDetailIndex].items[itemIndex].push({
        id: null, // id of invoice entry
        quantity: null // quantity of this invoice entry
      });
    },
    validateForm() {
      let validationFlag = true;
      this.visitDetailsForm.forEach(visitDetail => {
        if (Array.isArray(visitDetail.items) && visitDetail.items.length > 0) {
          visitDetail.items.forEach(
            visitDetailItem =>
              (validationFlag = validationFlag && visitDetailItem.isValid)
          );
        }
      });
      this.isValid = validationFlag;
      return this.isValid;
    },
    submitForm(event) {
      event.preventDefault();
      if (!this.validateForm()) this.showErrors = true;
      else this.finishVisit();
    },
    async finishVisit() {
      this.isPressed = true
      const submittedVisitDetails = [];
      this.visitDetailsForm.forEach(visitDetail => {
        const formatedItems = visitDetail.items.map(visitDetailItem => {
          const formatedEntries = visitDetailItem.invoicesForm.map(
            invoiceEntry => ({
              id: invoiceEntry.invoiceId,
              quantity: invoiceEntry.quantity
            })
          );

          return {
            id: visitDetailItem.itemId,
            invoice_entries: formatedEntries
          };
        });

        submittedVisitDetails.push({
          id: visitDetail.visitDetailId,
          package_id: visitDetail.packageId,
          discount_amount: visitDetail.discountAmount,
          final_cost_price: visitDetail.finalCostPrice,
          final_selling_price: visitDetail.finalSellingPrice,
          final_doctor_percentage: visitDetail.finalDoctorPercentage,
          items: formatedItems
        });
      });

      await this.$http
        .post(`reservation_visits/${this.reservationVisitId}/finish`, {
          clinic_id: this.clinicId,
          doctor_profit_as_discount: this.doctorProfitFlag,
          visit_details: submittedVisitDetails
        })
        .then(response => {
          this.navigateTo('Home');
        })
        .catch(error => {
          this.isPressed = false
          console.log('something happened error', error)
        });
    }
  }
};
</script>

<style scoped>
.packageSegment {
  margin-top: 12px !important;
  padding: 2rem 2rem !important;
}
.submitButton {
  width: 100%;
  display: flex;
  margin-top: 20px;
  align-items: center;
  justify-content: center;
}
.submitButton button {
  width: 70%;
}
.centered-header {
  display: flex;
  justify-content: center;
}
.centered-text {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
}
</style>



// WEBPACK FOOTER //
// src/components/visits/FinalizeVisit.vue